
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/auth.slice";
import loadingAPIReducer from "./slice/loadingAPI.slice";
import titleRouteReducer from "./slice/titleRoute.slice";
import userInfoReducer from "./slice/userInfo.slice";
import messageReducer from "./slice/message.slice";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./saga/root.saga";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: {
        auth: authReducer,
        messageSlice: messageReducer,
        loadingAPI: loadingAPIReducer,
        titleRoute: titleRouteReducer,
        userInfo: userInfoReducer,
    },
    devTools: true,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;